export default __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-9ae5ad8d821ac99500dd4bd269f5b1bf.otf";